import React from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';
import { useUnlayerDraftContext } from '@/context/UnlayerDraftContext';

/**
 * Confirms deletion of the currently selected draft.
 */
export const DeleteDraftDialog = () => {
	const {
		deleteSelectedDraft,
		isDeleteDraftDialogOpen,
		isDeletingDraft,
		setIsDeleteDraftDialogOpen,
	} = useUnlayerDraftContext();

	return (
		<Dialog
			open={isDeleteDraftDialogOpen}
			onClose={() => setIsDeleteDraftDialogOpen(false)}
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle>Delete Draft</DialogTitle>
			<DialogContent>
				<DialogContentText>Deleting this draft cannot be undone.</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setIsDeleteDraftDialogOpen(false)}>Cancel</Button>
				<Button
					variant='contained'
					color='error'
					onClick={deleteSelectedDraft}
					disabled={isDeletingDraft}
				>
					Delete Draft
				</Button>
			</DialogActions>
		</Dialog>
	);
};
